import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Skeleton } from 'antd';
import { actionsApi } from '../../shared';
import { DashboardCard } from './DashboardCard';
import { useTranslation } from 'react-i18next';  // i18n import

const CardComponent = ({ userData }) => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state?.dashboard);
  const [state, setState] = useState([]);
  const { pagination } = useSelector((state) => state?.addEditBox);

  const { t } = useTranslation();  // i18n hook

  useEffect(() => {
    if (data && userData && pagination) {
      setState([
        {
          title: t("Total token"),
          count: data?.totalToken,
          icon: "totalvendor.png",
        },
        {
          title: t("Remaining token"),
          count:
            userData.role == "masterVendor"
              ? data.remainingToken - pagination.totalRecords
              : data.remainingToken,
          icon: "remaintoken.png",
        },
        {
          title: t("Registered Devices"),
          count: data?.registeredDevices,
          icon: "totaldev.png",
        },
      ]);
    } else setState([]);
  }, [data, userData, pagination, t]);

  return (
    <div>
      <Row gutter={[16, 24]}>
        {loading
          ? new Array(4)?.fill(null)?.map((_, index) => (
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                xl={6}
                key={"skelton-card-" + index}
              >
                <Skeleton.Button
                  active
                  size="large"
                  shape="square"
                  block
                  style={{ width: "100%", height: "82px" }}
                  className="radius-20"
                />
              </Col>
            ))
          : state?.map((data, index) => (
              <Col xs={24} sm={24} md={12} lg={12} xl={6} key={"dashboard-card-" + index}>
                <DashboardCard data={data} />
              </Col>
            ))}
      </Row>
    </div>
  );
};

export { CardComponent };
